<div *ngIf='componentReady' class='EditUserReplay'>
  <div class='ContactsListing-header'>
    <div class='Breadcrumbs'>
      <div class='Breadcrumbs-items'>
        <a [routerLink]="['/contents', 'user_replies']"
        >
          <mat-icon class='Breadcrumbs-icon back'
          >keyboard_backspace
          </mat-icon
          >
        </a
        >
        <a
          [routerLink]="['/contents', 'user_replies']"
          class='Breadcrumbs-item first'
        >Response Group</a
        >
        <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
        <span class='Breadcrumbs-item'>{{ getReplayContentName() }}</span>
      </div>
    </div>
  </div>
  <div class='EditUserReplay-body mt-5 p-5'>
    <h2>Edit Replies</h2>
    <div class='EditUserReplay-form mt-3 p-5'>
      <form [formGroup]='formGroup'>
        <editor [init]='{indent: false,contextmenu: false}'
                apiKey='vh5cdpzhd4pw3dnz81yzmnw85e9965aysf26blj8m95hl5s1'
                class='my-3'
                formControlName='content'
                plugins='link lists'
                toolbar='undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist'></editor>
      </form>
    </div>
    <div class='EditUserReplay-footer mt-4 ms-5'>
      <app-button
        [color]='cancelButtonProperties.color'
        [route]='cancelButtonProperties.route'
        [size]='cancelButtonProperties.size'
        [text]='cancelButtonProperties.text'
        class='EditUserReplay-footer-button'></app-button>
      <app-button
        [Click]='submitButtonProperties.onClick'
        [color]='submitButtonProperties.color'
        [size]='submitButtonProperties.size'
        [text]='submitButtonProperties.text'
        [observeApi]="true"
        class='EditUserReplay-footer-button'></app-button>
    </div>
  </div>
</div>
